import FirstImage from '@/assets/svg/atlantm30/first.svg';
import SecondImage from '@/assets/svg/atlantm30/second.svg';
import ThirdImage from '@/assets/svg/atlantm30/third.svg';

export const numbers = [<FirstImage />, <SecondImage />, <ThirdImage />];
